import { render, staticRenderFns } from "./IssuedPassList.vue?vue&type=template&id=46840617&"
import script from "./IssuedPassList.vue?vue&type=script&lang=js&"
export * from "./IssuedPassList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports